// import { axiosInstance } from 'api/apiConfig'
import axiosInstance from 'axios'
import { useQuery } from 'react-query'

const address = async (params) => {
  const { data } = await axiosInstance.get(process.env.REACT_APP_JUSO_API_URL, { params, internal: false })
  return JSON.parse(data.slice(0, data.length - 1).slice(1))
}

/**
 * 주소 목록 조회
 * @param { searchShp, searchSiteId } params
 * @param {*} isInit
 * @returns
 */
export const useAddress = (keyword, isInit) => {
  return useQuery(
    ['address', keyword],
    () =>
      address({
        currentPage: 1,
        countPerPage: 999999,
        resultType: 'json',
        confmKey: process.env.REACT_APP_JUSO_API_KEY,
        keyword,
      }),
    {
      enabled: isInit,
    },
  )
}
